import React from "react";
import { Typography } from "antd";
import "./label.css";

const { Text } = Typography;

interface LabelProps {
  value: React.ReactNode;
}

const Label: React.FC<LabelProps> = ({ value }) => {
  if (!value) return null;

  return <Text className="source-label">{value}</Text>;
};

export default Label;
